import { NumberFormat } from '@billy/design-system'
import { useCallback, useMemo } from 'react'

import { DEFAULT_CURRENCY } from '@features/invoices/constants/defaultCurrency'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getCurrentLocale } from '../../../utils'
import { DEFAULT_CURRENCY_NUMBER_FORMAT_OPTIONS } from '../constants/defaultCurrencyNumberFormatOptions'
import { SalesReportTotalSales } from '../types/salesReportTotalSales'
import { calculateTotalSales } from '../utils/calculateTotalSales'
import { useSalesReportFilters } from './useSalesReportFilters'

export const useTotalSales = (salesReport: SalesReportTotalSales[]) => {
  const { organization } = useUserOrganization()
  const [{ shouldShowVat }] = useSalesReportFilters()

  const { grossTotal, netTotal } = useMemo(() => calculateTotalSales(salesReport), [salesReport])
  const currency = organization?.baseCurrencyId || DEFAULT_CURRENCY
  const locale = getCurrentLocale()
  const totalSales = shouldShowVat ? grossTotal : netTotal

  const formatTotalSalesAmount = useCallback(
    (value: number) => NumberFormat.getCurrencyNumber(value, currency, locale, DEFAULT_CURRENCY_NUMBER_FORMAT_OPTIONS),
    [currency, locale],
  )
  const grossTotalSales = formatTotalSalesAmount(grossTotal)
  const netTotalSales = formatTotalSalesAmount(netTotal)
  const displayedTotalSales = formatTotalSalesAmount(totalSales)

  return { grossTotalSales, netTotalSales, displayedTotalSales }
}
